module.exports = __webpack_public_path__ + "static/media/gifts.1c6eef06.svg";